import { render, staticRenderFns } from "./panel-rmheader-settings.vue?vue&type=template&id=d44a83e0&"
import script from "./panel-rmheader-settings.vue?vue&type=script&lang=js&"
export * from "./panel-rmheader-settings.vue?vue&type=script&lang=js&"
import style0 from "./panel-rmheader-settings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports